// store.js
import { create } from "zustand";

const useAuthStore = create((set) => ({
  user: JSON.parse(localStorage.getItem("user") || sessionStorage.getItem("user")),
  token: localStorage.getItem("pickc:token") || sessionStorage.getItem("pickc:token"),
  refreshToken: localStorage.getItem("pickc:refreshToken"),
  setUser: (user) => {
    if (user?.autologin) {
      localStorage.setItem("user", JSON.stringify(user));
    } else {
      sessionStorage.setItem("user", JSON.stringify(user));
    }
    set({ user });
  },
  login: (user, token, refreshToken) => {
    if (user?.autologin) {
      sessionStorage.clear();
      localStorage.setItem("user", JSON.stringify(user));
      localStorage.setItem("pickc:token", token);
      localStorage.setItem("pickc:refreshToken", refreshToken);
      set({ user, token, refreshToken });
    } else {
      localStorage.clear();
      sessionStorage.setItem("user", JSON.stringify(user));
      sessionStorage.setItem("pickc:token", token);
      set({ user, token });
    }
  },
  logout: () => {
    localStorage.clear();
    sessionStorage.clear();
    set({ user: null, token: null, refreshToken: null });
  },
}));

export default useAuthStore;
